import React from 'react';
import initVars from '../resources/json/initVars';
import MoConfiguration from '../MoConfiguration';

const ConfigContext = React.createContext(new MoConfiguration(initVars));

export default ConfigContext;
